export default {
  nav: {
    home: 'Strona główna',
    shoppingGuide: 'Przewodnik Zakupowy',
    guide: 'Przewodnik po Spreadsheet',
    categories: 'Kategorie',
    buyNow: 'Kup Teraz',
    language: 'Język',
  },
  hero: {
    badge: 'Niezależne Źródło · Regularnie Aktualizowane · Zorientowane na Bezpieczeństwo',
    title: 'USFans Spreadsheet — Znajdź Sprzedawców, Produkty i Zasoby',
    subtitle:
      'Poznaj najnowsze zasoby USFans spreadsheet, listy sprzedawców, przewodniki po produktach, informacje QC, wskazówki dotyczące wysyłki, recenzje i zasoby bezpieczeństwa — wszystko w jednym miejscu.',
    cta1: 'USFans Spreadsheet',
    cta2: 'Kup Teraz',
    trust: 'Niezależne Źródło · Regularnie Aktualizowane · Zorientowane na Bezpieczeństwo',
    disclaimer:
      'USFansSheet.link to niezależne źródło informacji i nie jest koniecznie powiązane z USFans. Zawsze weryfikuj ważne informacje przed zakupem.',
    cardTitle: 'Podgląd Spreadsheet',
    cardSeller: 'Sprzedawca',
    cardProduct: 'Produkt',
    cardCategory: 'Kategoria',
    cardQc: 'QC',
    cardShipping: 'Wysyłka',
    cardStatus: 'Status',
    cardUpdated: 'Zaktualizowano',
  },
  categorySection: {
    title: 'Przeglądaj Kategorie Produktów',
    subtitle:
      'Przejdź bezpośrednio do kategorii, której szukasz. Każdy link otwiera odpowiednią sekcję na głównej witrynie.',
    dropdownLabel: 'Wybierz kategorię',
    allCategories: 'Wszystkie kategorie',
    goTo: 'Otwórz kategorię',
  },
  about: {
    title: 'Czym Jest USFans Spreadsheet?',
    subtitle:
      'Zorganizowany sposób odkrywania produktów, sprzedawców i zasobów zakupowych bez przeszukiwania rozproszonych informacji.',
    p1: 'USFans spreadsheet to uporządkowany sposób odkrywania produktów, sprzedawców i przydatnych zasobów zakupowych bez przeszukiwania rozproszonych informacji. Nasze centrum USFans Spreadsheet porządkuje informacje o sprzedawcach, kategorie produktów, zasoby QC, przewodniki po wysyłce i powiązane informacje w łatwiejszym do użycia formacie.',
    p2: 'Niezależnie od tego, czy szukasz butów, bluz, koszulek, toreb czy akcesoriów, możesz zacząć tutaj i przejść do głównej witryny, aby przeglądać pełny katalog.',
    cta: 'Poznaj USFans Spreadsheet',
  },
  features: {
    title: 'Wszystko, czego Potrzebujesz, by Poznać USFans w Jednym Miejscu',
    subtitle: 'Przejrzysty punkt wyjścia do sprzedawców, produktów, QC, wysyłki i bezpieczeństwa.',
    seller: {
      title: 'Odkrywanie Sprzedawców',
      desc: 'Znajdź uporządkowane zasoby o sprzedawcach i porównaj istotne informacje.',
    },
    product: {
      title: 'Odkrywanie Produktów',
      desc: 'Poznaj popularne kategorie produktów i powiązane zasoby spreadsheet.',
    },
    qc: {
      title: 'Zasoby QC',
      desc: 'Dowiedz się, jak informacje i zdjęcia QC pomagają oceniać produkty.',
    },
    shipping: {
      title: 'Przewodniki Wysyłki',
      desc: 'Zrozum metody wysyłki, koszty i ważne kwestie.',
    },
    safety: {
      title: 'Zasoby Bezpieczeństwa',
      desc: 'Dowiedz się, jak oceniać linki, sprzedawców, płatności i ryzyko zakupu.',
    },
    updated: {
      title: 'Aktualizowane Zasoby',
      desc: 'Utrzymuj ważne informacje w porządku i łatwe do ponownego sprawdzenia.',
    },
  },
  article: {
    title: 'Przewodnik USFans Spreadsheet',
    subtitle:
      'Przeczytaj nasz szczegółowy przewodnik, aby zrozumieć sprzedawców, produkty, QC, wysyłkę i bezpieczeństwo przed zakupem.',
    cardTitle: 'USFans Spreadsheet: Kompletny Przewodnik',
    cardDesc:
      'Dowiedz się, czym jest USFans spreadsheet, jak znaleźć sprzedawców i produkty oraz jak kupować bezpiecznie.',
    readMore: 'Przeczytaj pełny przewodnik',
    readGuide: 'Otwórz przewodnik',
    minutes: '7 min czytania',
    related: 'Powiązane Przewodniki',
    tableTitle: 'Tabela Referencyjna',
    pros: 'Zalety',
    cons: 'Wady',
    notFound: 'Nie znaleziono przewodnika',
  },
  articleSection: {
    title: 'Przewodniki i Zasoby USFans',
    subtitle:
      'Poznaj naszą bibliotekę niezależnych przewodników o sprzedawcach, produktach, QC, wysyłce, kuponach, bezpieczeństwie i nie tylko.',
  },
  faq: {
    title: 'Najczęściej Zadawane Pytania',
    subtitle: 'Szybkie odpowiedzi na najczęstsze pytania o USFans spreadsheet.',
    q1: {
      q: 'Czym jest USFans spreadsheet?',
      a: 'USFans spreadsheet to uporządkowana tabela, która zbiera sprzedawców, produkty, kategorie, informacje QC i notatki o wysyłce w jednym miejscu.',
    },
    q2: {
      q: 'Czy USFansSheet.link jest powiązany z USFans?',
      a: 'Nie. USFansSheet.link to niezależne źródło informacji i nie jest koniecznie powiązane z USFans.',
    },
    q3: {
      q: 'Jak znaleźć produkty?',
      a: 'Skorzystaj z katalogu kategorii na tej stronie, aby przejść do butów, bluz, koszulek i innych kategorii na głównej witrynie.',
    },
    q4: {
      q: 'Czy powinienem sprawdzić QC przed zakupem?',
      a: 'Tak. Przejrzenie zdjęć i notatek QC może pomóc potwierdzić, że przedmiot pasuje do opisu, zanim zostanie wysłany.',
    },
  },
  cta: {
    title: 'Gotowy, by Poznać USFans Spreadsheet?',
    subtitle:
      'Zacznij od centrum spreadsheet, porównaj dostępne zasoby i znajdź potrzebne informacje, zanim przejdziesz do głównej witryny.',
    button1: 'Otwórz USFans Spreadsheet',
    button2: 'Kup Teraz',
  },
  footer: {
    tagline:
      'Niezależne centrum zasobów do odkrywania sprzedawców, produktów, QC i informacji zakupowych USFans.',
    disclaimer:
      'USFansSheet.link to niezależne źródło informacji i nie jest koniecznie powiązane ani zatwierdzone przez USFans. Informacje mogą się zmieniać; weryfikuj szczegóły w oficjalnych źródłach.',
    categories: 'Kategorie',
    resources: 'Zasoby',
    guide: 'Przewodnik po Spreadsheet',
    home: 'Strona główna',
    backToTop: 'Wróć na górę',
    rights: 'Wszelkie prawa zastrzeżone.',
  },
  categoryNames: {
    shoes: 'Buty',
    hoodies: 'Bluzy / Swetry',
    tshirts: 'Koszulki',
    jackets: 'Kurtki',
    pants: 'Spodnie / Szorty',
    headwear: 'Nakrycia głowy',
    sets: 'Zestawy',
    underwear: 'Bielizna',
    jersey: 'Koszulka sportowa',
    accessories: 'Akcesoria',
    bags: 'Torby',
    belts: 'Paski',
    perfumes: 'Perfumy',
    other: 'Inne',
  },
};